import React from "react";
import { Route } from "react-router-dom";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import config from "../../config.js";

import { setMetatags } from "../../modules/metatag_functions.js";
import { setRedirectUrl } from "Skelet/src/modules/fetch.action.js";
import Header from "./CoreRouteHeader.js";

class CoreRoute extends React.Component {
  componentDidMount() {
    if (!this.props.session_token) {
      this.props.setRedirectUrl(this.props.currentURL);
      this.props.redirectToLogin();
    }
  }

  render() {
    /* todo i18n: terms and conditions, privacy policy */
    if (this.props.session_token) {
      setMetatags();
      return (
        <div>
          <Header config={config} />
          <main>
            <Route {...this.props} />
          </main>
          <div
            className="container"
            style={{
              color: "#aaa",
              margin: "3em auto 1em",
              paddingBottom: "1em",
              textAlign: "center",
              fontSize: "80%",
            }}
          >
            <span>
              <a
                href="https://dieet.club/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Dieet.Club
              </a>
            </span>
            <span>
              <span> | </span>
              <a
                href="https://polymedia.nl/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Polymedia.nl
              </a>{" "}
              ©{new Date().getFullYear()}
            </span>
            <span>
              <span> | </span>
              <a href="/terms" target="_blank" rel="noopener noreferrer">
                algemene voorwaarden
              </a>
            </span>
            <span>
              <span> | </span>
              <a href="/privacy" target="_blank" rel="noopener noreferrer">
                privacybeleid
              </a>
            </span>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

function mapStateToProps(state, ownProps) {
  let session_token = null;
  if (
    state.apiData["login"] !== undefined &&
    state.apiData["login"]["data"]["token"] !== undefined
  ) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    currentURL: ownProps.location.pathname,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      redirectToLogin: () => push("/start"),
      setRedirectUrl,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CoreRoute);



// WEBPACK FOOTER //
// ./src/containers/route-containers/CoreRoute.js